import { Injectable } from '@angular/core';

@Injectable()
export class ApiKeys {
  static GET_PANIER = 'GET_PANIER';
  static GET_FOURNISSEURS = 'GET_FOURNISSEURS';
  static PUT_AJOUT_PANIER = 'PUT_AJOUT_PANIER';
  static DELETE_LIGNE_PANIER = 'DELETE_LIGNE_PANIER';
  static PUT_PAY = 'PUT_PAY';
  static PUT_CANCEL_PAYEMENT = 'PUT_CANCEL_PAYEMENT';
  static PUT_CLEAR_PAYEMENT = 'PUT_CLEAR_PAYEMENT';
  static PUT_ENVOYER_MAIL = 'PUT_ENVOYER_MAIL';
  static GET_RECLAMATION_LITIGE = 'GET_RECLAMATION_LITIGE';
  static GET_RECLAMATION_LITIGE_BY_DATE = 'GET_RECLAMATION_LITIGE_BY_DATE';
  static GET_CONTACTS_INFO = 'GET_CONTACTS_INFO';
  static GET_ACCOUNT_LIST = 'GET_ACCOUNT_LIST';
  static CHECK_BILLINGFILE_EXISTS = 'CHECK_BILLINGFILE_EXISTS';
  static GET_SOLDE_PAY_LIST = 'GET_SOLDE_PAY_LIST';
  static GET_BON_CMD_LIST = 'GET_BON_CMD_LIST';
  static GET_EXTRAIT_LIST = 'GET_EXTRAIT_LIST';
  static GET_EXTRAIT_LIST_CSV = 'GET_EXTRAIT_LIST_CSV';
  static GET_CARD_LIST = 'GET_CARD_LIST';
  static GET_CARD = 'GET_CARD';
  static PUT_CARD_DEFAULT = 'PUT_CARD_DEFAULT';
  static DELETE_CARD = 'DELETE_CARD';
  static GET_DOCUMENT_RIB = 'GET_DOCUMENT_RIB';
  static GET_ADDRESSES = 'GET_ADDRESSES';
  static GET_URL_IFRAME_SIGN = 'GET_URL_IFRAME_SIGN';
  static POST_CONTACT_SIGN = 'POST_CONTACT_SIGN';
  static GET_SEPAMANDATE_LIST = 'GET_SEPAMANDATE_LIST';
  static GET_MANDAT_SEPA_LINK = 'GET_MANDAT_SEPA_LINK';
  static POST_SEPA_GENERATE = 'POST_SEPA_GENERATE';
  static GET_SEPA_STATUS = 'GET_SEPA_STATUS';
  static GET_SEPA_STATUS_CONNECT = 'GET_SEPA_STATUS_CONNECT';
  static GET_ACCESS_SEPA = 'GET_ACCESS_SEPA';
  static GET_LIST_SEPA_MANDATE = 'GET_LIST_SEPA_MANDATE';
  static GET_EXCHANGE_TOKENS = 'GET_EXCHANGE_TOKENS';
  static GET_USER_INFO = 'GET_USER_INFO';
  static GET_NAVIGATION = 'GET_NAVIGATION';
  static POST_DIRECT_DEBIT_ORDER = 'POST_DIRECT_DEBIT_ORDER';
  static GET_UNSIGNED_BDC = 'GET_UNSIGNED_BDC';
  static POST_SEPA_INFOS = 'POST_SEPA_INFOS';
  static POST_ERROR_BDC = 'POST_ERROR_BDC';
  static GET_NB_LATE_BILLS = 'GET_NB_LATE_BILLS';
}

@Injectable()
export class SortKey {
  static PANIER_DEFAUT_SORT = 'PANIER_DEFAUT_SORT';
}
